import Entity from '../../../../../../foundation/domain/Entity';
import EntityId from '../../../../../../foundation/domain/EntityId';
import OrganizationType from './OrganizationType';

export default class Organization extends Entity<Organization> {

	public constructor (id: EntityId<Organization>, private type: OrganizationType, private name: string) {
		super(id);
	}

	public getType () {
		return this.type;
	}

	public getName () {
		return this.name;
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/organizations/domain/aggregates/organization/Organization.ts